import { isApiEntity } from '@backstage/catalog-model';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { apiSpecApiRef, datacontractsApiRef } from './apis';

export const apiSpecPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'api-spec',
      params: defineParams =>
        defineParams({
          apiRef: apiSpecApiRef,
          path: 'api-spec',
        }),
    }),
    TrpcApiBlueprint.make({
      name: 'datacontracts',
      params: defineParams =>
        defineParams({
          apiRef: datacontractsApiRef,
          path: 'datacontracts',
        }),
    }),
    EntityContentBlueprint.make({
      name: 'EntityContentApiDiff',
      params: {
        filter: isApiEntity,
        icon: <Icon icon="ic:baseline-difference" />,
        loader: async () =>
          import('./components/ApiDiffPage/ApiDiffPage').then(m => (
            <m.ApiDiffPage />
          )),
        path: '/diff',
        title: 'Diff',
      },
    }),

    EntityContentBlueprint.make({
      name: 'EntityContentApiDefinition',
      params: {
        filter: isApiEntity,
        icon: <Icon icon="carbon:api-1" />,
        loader: async () =>
          import('./components/ApiDefinitionCard/ApiDefinitionCard').then(m => (
            <m.ApiDefinitionCard />
          )),
        path: '/definition',
        title: 'Definition',
      },
    }),

    PageBlueprint.make({
      name: 'OAuth2Redirect',
      params: {
        loader: async () =>
          import('./components/OAuth2Redirect').then(m => <m.OAuth2Redirect />),
        noHeader: true,
        path: '/oauth2-redirect.html',
      },
    }),
  ],
  pluginId: 'api-spec',
});
